import React from "react";
import HumanBanner from "../humanresources/HumanBanner";
import MobileCapture from "./MobileCapture";
import MobileAnyx from "./MobileAnyx";
import HomeTestimonial from "../../home/HomeTestimonial";
import MobileBlog from "./MobileBlog";
import HomeCta from "../../home/HomeCta";
export default function MobileWorkforce({ initialData }) {
  const bannerData = {
    head: "Empowering a Connected, Mobile Workforce",
    desc: "In today’s digital-first world, work is no longer confined to a single location. Empowering Dox and Box enables organizations to support a flexible, distributed workforce with secure access to documents and workflows, anytime, anywhere, on any device.",
    slug: "",
    btn: "Contact Us",
    img: "/assets/images/mobile-workspace-banner.webp"
  }

const testimonialData = {
    title: "Trusted by industry leaders",
    slides: [
      {
        title:"“Secure Financial Document Management”",
        desc:"Managing large volumes of sensitive financial records was a constant operational challenge for us. Dox and Box transformed the way we handle documentation with their secure off-site storage and seamless retrieval system. Their digitization process significantly improved our audit readiness and reduced internal workload. The reliability and compliance standards they maintain have made them a long-term partner in our data management strategy.",
        image:"/assets/images/testimonial-user-1.webp",
        name: "Rajiv Mehra",
        designation: "Head of Compliance",
      },
      {
        title:"“Trusted Healthcare Record Partner”",
        desc:"Data security and confidentiality are critical in the healthcare industry, Dox and Box has consistently met those expectations. Their structured approach to records management, combined with secure digitization and cloud access, has helped us streamline patient record handling. Their team understands regulatory requirements extremely well and ensures complete compliance at every stage.",
        image:"/assets/images/testimonial-user-2.webp",
        name: "Dr. Neha Sharma",
        designation: "Operations Director",
      },
      {
        title:"“Efficient Legal Document Access”",
        desc:"Our firm deals with extensive case files and long-term documentation requirements. Dox and Box provided us with a highly efficient document management system that allows instant access to archived legal records. Their vault storage and secure shredding services have added an extra layer of confidence in maintaining client confidentiality and regulatory compliance",
        image:"/assets/images/testimonial-user-3.webp",
        name: "Amit Kapoor",
        designation: "Corporate Lawyer",
      },
      {
        title:"“Streamlined Enterprise Documentation”",
        desc:"Scaling operations meant dealing with an overwhelming amount of business records across multiple locations. Dox and Box helped us centralize and organize our entire document ecosystem. Their barcoding, indexing, retrieval systems have significantly improved operational efficiency and reduced dependency on physical storage. They have become a crucial part of our back-end infrastructure.",
        image:"/assets/images/testimonial-user-4.webp",
        name: "Sanjay Verma",
        designation: "Head of Operations",
      },
      {
        title:"“Reliable Insurance Records Management”",
        desc:"Handling policy documents and claims records at scale required a system that was both secure and easily accessible. Dox and Box provided us with a structured document management framework that streamlined our entire records lifecycle. Their digitization and indexing capabilities have significantly improved retrieval speed and reduced processing delays. The consistency and compliance they bring have made them an essential partner in our operations.",
        image:"/assets/images/testimonial-user-5.webp",
        name: "Anjali Deshmukh",
        designation: "Operations Head",
      },
      {
        title:"“Optimized Corporate Document Control”",
        desc:"Our organization deals with a vast number of internal and client-facing documents across multiple departments. Dox and Box helped us centralize and secure our entire document ecosystem with a highly efficient storage and retrieval system. Their attention to compliance, security, operational efficiency has reduced our dependency on manual processes and improved overall productivity across teams",
        image:"/assets/images/testimonial-user-6.webp",
        name: "Vikram Sethi",
        designation: "Chief Administrative Officer",
      },
      
    ],
  };

  return (
    <>
      <HumanBanner data={bannerData} />
      <MobileCapture />
      <MobileAnyx />
      <HomeTestimonial data={testimonialData} />
      <MobileBlog initialData={initialData?.blogs}/>
      <HomeCta />
    </>
  )
}